import { AppTierGq, AppTierGqProps } from '../../projects/models/AppTierGq';
import { CustomAppTierSettingGq } from './CustomAppTierSettingGq';
import { PublicTeamGq, PublicTeamGqProps } from './PublicTeamGq';
import { SubscriptionPeriodGq, SubscriptionPeriodGqProps } from './SubscriptionPeriodGq';
import { UserTeamRoleGq } from './UserTeamRoleGq';

export interface CurrentTeamGq {
  accessUserCanEditBasicSettings: boolean;
  accessUserCanEditBilling: boolean;
  accessUserCanEditMembersUpTo?: UserTeamRoleGq;
  accessUserCanEditTeamConnections: boolean;
  activeChildConnections: number;
  activeSubscriptionPeriod?: SubscriptionPeriodGq;
  activeUsers: number;
  appTier: AppTierGq;
  betaTester: boolean;
  blockMonthlyProxies: boolean;
  blockMonthlyUseChatGptDrafts: boolean;
  blockMonthlyUseRankKw: boolean;
  blockMonthlyUseSearchVolumeKw: boolean;
  blockMonthlyUseTranslateKw: boolean;
  canAccessChildTeams: boolean;
  canInviteTeamMembers: boolean;
  createTime: string;
  customAppTier?: AppTierGq;
  customAppTierSetting?: CustomAppTierSettingGq;
  defaultPaletteId?: number;
  eligibleForSponsoredSubscription: boolean;
  id: number;
  licenses: number;
  name: string;
  specialAnalysisTheme?: string;
  setupCompletedTeamMembers: boolean;
  sponsoredSubscriptionProvidedBy: PublicTeamGq[];
  stripeCustomerAvailable: boolean;
  stripeSubscriptionAvailable: boolean;
  subscriptionExpiresAt?: string;
  subscriptionPeriods: SubscriptionPeriodGq[];
  subscriptionStartsAt?: string;
  trialExpiresAt?: string;
  voxelTeam: boolean;
  allowedEmailDomains?: string[];
}

export const CurrentTeamGqProps = `
  accessUserCanEditBasicSettings
  accessUserCanEditBilling
  accessUserCanEditMembersUpTo
  accessUserCanEditTeamConnections
  activeChildConnections
  activeSubscriptionPeriod { ${SubscriptionPeriodGqProps} }
  activeUsers
  appTier { ${AppTierGqProps} }
  betaTester
  blockMonthlyProxies
  blockMonthlyUseChatGptDrafts
  blockMonthlyUseRankKw
  blockMonthlyUseSearchVolumeKw
  blockMonthlyUseTranslateKw
  canAccessChildTeams
  canInviteTeamMembers
  createTime
  customAppTier { ${AppTierGqProps} }
  customAppTierSetting
  defaultPaletteId
  eligibleForSponsoredSubscription
  id
  licenses
  name
  setupCompletedTeamMembers
  specialAnalysisTheme
  sponsoredSubscriptionProvidedBy { ${PublicTeamGqProps} }
  stripeCustomerAvailable
  stripeSubscriptionAvailable
  stripeSubscriptionExpiresAt
  subscriptionPeriods { ${SubscriptionPeriodGqProps} }
  subscriptionStartsAt
  trialExpiresAt
  voxelTeam
  allowedEmailDomains
`;
